/**
 * created by mgg
 * 投稿公用表格
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Pagination, Table} from "antd";
import "./ManagementTable.css";

export default class ManagementTable extends Component {
    static defaultProps = {
        columns: [],
        dataSource: [],
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    //表格
    render() {
        let {columns, dataSource} = this.props;
        return (
            <div style={{marginTop:15,height:"1000px"}}>
                <Table columns={columns}
                       dataSource={dataSource}
                       pagination={false}
                       rowKey="id"
                       rowClassName={this.getRowClassName}
                >
                </Table>
                {this.renderFooter()}
            </div>
        )
    };

    //页脚
    renderFooter(){
        return(
            <div style={{display: 'flex', justifyContent: "flex-end", marginTop: 20}}>
                <Pagination defaultCurrent={1} total={50} />
            </div>
        )
    };

    //表格行背景色
    getRowClassName = (record, index) => {
        let className = '';
        className = index % 2 === 0 ? "evenRow" : "oddRow" ;
        return className;
    };

}